import { createFileRoute, redirect } from '@tanstack/react-router';
import { meQueryOptions } from '../auth/session.js';
import { getToken, setToken } from '../auth/token-store.js';
import { ApiError } from '../lib/api.js';
import { AppShell } from '../shell/app-shell.js';
import { ShellError, ShellPending } from '../shell/route-states.js';

// Everything under this layout needs a session that GET /me accepts.
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    if (!getToken()) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
    try {
      await context.queryClient.ensureQueryData(meQueryOptions());
    } catch (error) {
      if (error instanceof ApiError && (error.status === 401 || error.status === 403)) {
        setToken(null);
        context.queryClient.clear();
        throw redirect({ to: '/login', search: { redirect: location.href, reason: 'expired' } });
      }
      throw error;
    }
  },
  component: AppShell,
  // Loading and failure keep the frame (navigation, connection, Sign out) around them.
  pendingComponent: ShellPending,
  errorComponent: ShellError,
});
